import { useSaved } from "../context/SavedContext";

function SaveButton({ id, variant = "full", title, block = false }) {
  const { isSaved, toggle } = useSaved();
  const saved = isSaved(id);

  const action = saved ? "Retirer des favoris" : "Ajouter aux favoris";
  const label = title ? `${action} : ${title}` : action;
  const icon = saved ? "bi bi-bookmark-fill" : "bi bi-bookmark";

  if (variant === "icon") {
    return (
      <button
        type="button"
        className="pa-icon-btn"
        aria-pressed={saved}
        aria-label={label}
        title={action}
        onClick={() => toggle(id)}
      >
        <i className={icon} aria-hidden="true"></i>
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`pa-btn pa-btn--ghost${block ? " pa-btn--block" : ""}`}
      aria-pressed={saved}
      aria-label={label}
      onClick={() => toggle(id)}
    >
      <i className={icon} aria-hidden="true"></i>
      {saved ? "Enregistré" : "Enregistrer"}
    </button>
  );
}

export default SaveButton;
